import type { ServerEventMessage } from '@momentum/shared';

export type MusicTrack = 'map' | 'decision' | 'potato';
export type EffectCue = { sound: 'crystal' | 'jump'; delayMs: number };

export function musicTrackFor(moduleId: string | null | undefined): MusicTrack | null {
  if (moduleId === 'decision-maker') return 'decision';
  if (moduleId === 'hot-potato') return 'potato';
  if (moduleId === 'momentum-board-v2' || moduleId === 'momentum-board') return 'map';
  return null;
}

/** A first snapshot and a reconnect to the same child are settled state, not new transitions. */
export function shouldPlayActivityTransition(previousChildId: string | null, nextChildId: string | null): boolean {
  return nextChildId !== null && previousChildId !== nextChildId;
}

/** Ephemeral events arrive only when they happen, so this never reconstructs old sounds from a snapshot. */
export function effectCuesForEvent(event: ServerEventMessage): EffectCue[] {
  if (event.name === 'board.crystal') return [{ sound: 'crystal', delayMs: 0 }];
  if (event.name !== 'board.move') return [];
  const path = (event.payload as { path?: unknown } | null)?.path;
  if (!Array.isArray(path)) return [];
  return path.map((_, index) => ({ sound: 'jump', delayMs: index * 750 }));
}
